import classnames from 'classnames';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { ReactComponent as CopyIcon } from 'pages/Cash/pages/DirectDepositInformation/assets/copy.svg';
import React from 'react';

const DirectDepositInfoField = ({
  title,
  value,
  onClickCopy,
  className,
  datatestid,
  valueClassName,
  titleClassName,
}) => {
  const finalTitleClassNames =
    titleClassName ??
    'text-16 t-text-16 bold m-padB8 Subtitle-1 fontNeutral500  format60 t-format100';
  return (
    <FlexContainer
      className={classnames(
        'justify-between flex-row align-items-center  padTB20 m-padTB16 ',
        className,
      )}
    >
      <FlexContainer className="mob-flex-column flex-row format80 t-format60 justify-between m-format80 align-baseline">
        <div className={finalTitleClassNames}>{title}</div>
        <div
          data-testid={'directdeposit-' + datatestid + '-value'}
          className="Body-1 fontNeutral500 t-hide format40 t-format100"
        >
          {value}
        </div>
        <div
          data-testid={'directdeposit-' + datatestid + '-value-mob'}
          className="Body-2 fontNeutral500 d-hide  format40 t-format100"
        >
          {value}
        </div>
      </FlexContainer>
      <FlexContainer
        data-testid={'directdeposit-' + datatestid + '-copy'}
        onClick={() => onClickCopy(title, value)}
        className="pos-rel format20 t-format100 justify-end"
      >
        <div
          style={{
            height: 35,
            width: 35,
            opacity: 0.3,
            top: -6,
            left: -6,
            zIndex: 1,
          }}
          className="grayBgAnimation border-rad50 pos-abs"
        />
        <CopyIcon aria-label="copy-icon" />
      </FlexContainer>
    </FlexContainer>
  );
};

DirectDepositInfoField.defaultProps = {
  valueClassName: 'text-14',
};

export default DirectDepositInfoField;
